// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"DeleteButton_deleteButton__2iYFV"};